import {
  interaction_repository,
} from '@/repositories';

const actions = {
  async getUserStatistics(_, input) {
    const {
      statistics,
    } = await interaction_repository.getUserStatistics(input);

    return statistics;
  },

  async getStatisticsByInteractionType(_, input) {
    const {
      date_lower_boundary,
      date_upper_boundary,
    } = input;

    if (!date_lower_boundary || !date_upper_boundary) {
      return {
        statistics: {},
      };
    }

    const {
      statistics,
    } = await interaction_repository.getStatisticsByInteractionType(input);

    return statistics;
  },

  async createInteraction(_, input) {
    const result = await interaction_repository.createInteraction(input);

    return result;
  },

  async getInteractions(_, input) {
    const {
      interaction_list,
    } = await interaction_repository.getInteractions(input);

    return interaction_list;
  },

  async deleteInteraction(_, interaction_id) {
    const result = await interaction_repository.deleteInteraction(interaction_id);

    return result;
  },
};

export default {
  actions,
  namespaced: true,
};
